/* import __COLOCATED_TEMPLATE__ from './integrate.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type RouterService from '@ember/routing/router-service';
import { HandoffBehavior } from 'embercom/objects/standalone/constants';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

export interface Args {
  section: string | null;
  setSection?: (section: string | null) => void;
}

const NEXT_BUTTON_CONFIG = {
  salesforce: {
    labelKey: 'standalone.intercom-messenger.deploy.integrate.next-data.salesforce',
    nextPath: 'apps.app.standalone.deploy.intercom-messenger.data',
  },
  zendesk: {
    labelKey: 'standalone.intercom-messenger.deploy.integrate.next-data.zendesk',
    nextPath: 'apps.app.standalone.deploy.intercom-messenger.data',
  },
  default: {
    labelKey: 'standalone.intercom-messenger.deploy.integrate.next',
    nextPath: 'apps.app.standalone.deploy.intercom-messenger.workflow',
  },
};

export default class Integrate extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare finStandaloneService: FinStandaloneService;

  get intercomMessengerConfig() {
    return this.finStandaloneService.intercomMessengerConfig;
  }

  get showSunshineMultipleConversationsSection() {
    return (
      this.intercomMessengerConfig.handoffBehavior !== HandoffBehavior.ZendeskTicket ||
      this.finStandaloneService.zendeskConfig?.sunshineIntegration?.isSunshineConnected ||
      false
    );
  }

  get nextButtonConfig() {
    let key = 'default';

    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      key = 'salesforce';
    } else if (this.appService.app.hasStandalonePlatform('zendesk')) {
      key = 'zendesk';
    }

    return NEXT_BUTTON_CONFIG[key as keyof typeof NEXT_BUTTON_CONFIG];
  }

  @action
  setSection(section: string | null): void {
    this.args.setSection?.(section);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::IntercomMessenger::Deploy::Integrate': typeof Integrate;
    'standalone/intercom-messenger/deploy/integrate': typeof Integrate;
  }
}
